module.exports = __webpack_public_path__ + "static/media/ProfilePicture.de0bd8ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ProfilePicture.jpg
// module id = 41
// module chunks = 0